<span class="nav-link d-flex flex-row" role="button" [ngClass]="{'active': isActive}">
  <span
    *ngIf="canShowChildren"
    (click)="toggleChildren()"
    [class.opacity-50]="isLoadingChildren"
    [style.pointer-events]="isLoadingChildren ? 'none' : 'auto'"
  >
    <fa-icon class="me-1" *ngIf="!showChildren && !isLoadingChildren" icon="chevron-right" [fixedWidth]="true"></fa-icon>
    <fa-icon class="me-1" *ngIf="showChildren && !isLoadingChildren" icon="chevron-down" [fixedWidth]="true"></fa-icon>
    <fa-icon class="me-1" *ngIf="isLoadingChildren" icon="spinner" [spin]="true" [fixedWidth]="true"></fa-icon>
  </span>
  <fa-icon class="me-1" *ngIf="!canShowChildren" icon="beer" style="visibility: hidden" [fixedWidth]="true"></fa-icon>
  <span class="d-inline-flex flex-row flex-grow-1" (click)="open()">
    <fa-icon class="me-2" *ngIf="node?.meta?.icon" [icon]="node.meta.icon" [fixedWidth]="true"></fa-icon>
    <fa-icon class="me-2" *ngIf="resourceIcon" [icon]="resourceIcon" [fixedWidth]="true"></fa-icon>
    <div class="nav-text" [class.reference]="reference">{{ node.name }}</div>
  </span>
</span>

<nav *ngIf="canShowChildren && showChildren" class="nav nav-pills flex-column">
  <span *ngIf="canCreate && !isReference" class="nav-link" role="button" (click)="create()">
    <fa-icon class="icon me-2" icon="plus"></fa-icon>
    New
  </span>

  <app-sidebar-segment
    *ngFor="let child of children; trackBy: trackByUUID"
    [activePath]="activePath"
    [mode]="mode"
    [node]="child"
    [reference]="reference || isReference"
  >
  </app-sidebar-segment>
</nav>
